module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Document_16"],"path":[{"$":{"d":"M9.3,2,13,5v9H3V2H9.3M10,0H1V16H15V4L10,0Zm1,7H5V8h6Zm0,2H5v1h6ZM9,5H5V6H9Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Document_16.svg
// module id = 0YDC
// module chunks = 1